export function generateDiscountLabel(onPromotion, price, onPromotionPrice) {
    if (!onPromotion)
        return "";
    const discountLabelPercentage = ((parseFloat(price) - parseFloat(onPromotionPrice)) / parseFloat(price)) * 100;
    return `${discountLabelPercentage.toFixed(0)}% OFF`;
}
